import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import './DocumentsList.scss';

const DocumentsList = ({
  documents,
  title,
}) => (
  <div className="row mt-5 mb-5">
    <h6>{title}</h6>
    <Table striped hover responsive>
      <thead>
        <tr>
          <th>File</th>
          <th>Data Type</th>
          <th>File MIME Type</th>
        </tr>
      </thead>
      <tbody>
        {documents && documents.length > 0 ? (
          documents.map(doc => (
            <tr>
              <td>
                <a
                  href={doc.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  {`${doc.name}`}
                </a>
              </td>
              <td>
                {doc.data_type ? (
                  `${doc.data_type.name} [${doc.data_type.code}]`
                ) : (
                  'Unknown'
                )}
              </td>
              <td>
                {doc.type}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={3} className="text-center pt-2">This product doesnt have any files attached to it.</td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

DocumentsList.propTypes = {
  title: PropTypes.string.isRequired,
  documents: PropTypes.array.isRequired,
};

DocumentsList.defaultProps = {

};

export default DocumentsList;
